import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { getToken } from '../../auth/authService'; // Adjust the import path as necessary

const CheckProfile = () => {
  const history = useHistory();

  useEffect(() => {
    const check = async () => {
      const token = getToken();
      const res = await fetch('/api/user/check-profile', {
        headers: { Authorization: `Bearer ${token}` },
      });
      const data = await res.json();
      if (data.exists) {
        history.push('/dashboard');
      } else {
        history.push('/complete-profile');
      }
    };
    check();
  }, [history]);

  return <div className="p-4 text-center">Checking profile...</div>;
};

export default CheckProfile;
